// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","StrollerBoxWidget":"bew_a bht_tr","StrollerBoxWidget__imageCounselling":"bew_b bht_kg"};